const DEFAULT_NEARBY_RADIUS_MILES = 50

export const getDefaultNearbyRadius = featureFlags =>
  featureFlags?.['fe.resi.search.default-nearby-radius'] ||
  DEFAULT_NEARBY_RADIUS_MILES
